import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import { closePopup, openPopup } from '../action';
import  {savePreLoginDataEcart,updateFolioEcart} from '../ECartModal/action';
import './style.scss';
import ENV_CONFIG from '../../../../../config/environment';
import { toast } from 'react-toastify';

const ReplaceItems = (props) => {
    const {preLoginData, url, uuid, folio, savePreLoginDataEcart, openPopup, closePopup, updateFolioEcart} = props;

    const onClickOfYes = async () => {
        let params = preLoginData;
        params.forceUpdate = true;
        let res = await savePreLoginDataEcart((JSON.stringify(params)), uuid);
        if(res && !res.status){
            const notify = () => toast.error(res.message);
            notify();
        }
        else if(res && res.status && res.data && !res.data.cartExists){
            const url =`${ENV_CONFIG.INVESTOR_BASE_URL}/ecart/${uuid}`;
            window.open(url,'_self');
        }
    }
    const onClickOfNo = async () => {
        let params = {
            "folioNumber":folio
        };
        await updateFolioEcart((JSON.stringify(params)), uuid);
        closePopup();
        const url =`${ENV_CONFIG.INVESTOR_BASE_URL}/ecart/${uuid}`;
        window.open(url,'_self');
    }

    return (
        <div className='e-kyc-modal replace-items'>
            <h3 className='message'>It looks like your cart already have schemes</h3>
            <h3 className='message'>Do you want to replace it?</h3>
            <div className="ctas">
                <a onClick={onClickOfYes}>Yes</a>
                <a onClick={onClickOfNo}>No</a>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    eCart: state.eCart,
});

const mapDispatchToProps = (dispatch) => ({
    savePreLoginDataEcart: bindActionCreators(savePreLoginDataEcart, dispatch),
    updateFolioEcart: bindActionCreators(updateFolioEcart, dispatch),
    closePopup: bindActionCreators(closePopup, dispatch),
    openPopup: bindActionCreators(openPopup, dispatch),
});

const ReplaceItemsContainer = connect(mapStateToProps, mapDispatchToProps)(ReplaceItems);

export default ReplaceItemsContainer;